<template>
    <div>
        <div data-validation-target="orderConfForm">
            <v-select
                label="Order Confirmation Form"
                :items="order_confirmation_form_choices"
                :value="template.order_confirmation_settings_id"
                hint="Associate this message with an Order Confirmation form"
                :disabled="read_only || order_confirmation_form_choices.length === 0"
                persistent-hint
                clearable
                @input="onUpdateOrderConfirmationSettingsId"
            >
                <template #append-outer>
                    <v-tooltip v-if="show_form_link && template.order_confirmation_settings_id" bottom>
                        <template #activator="{ on, attrs }">
                            <v-btn
                                :disabled="read_only"
                                v-bind="attrs"
                                v-on="on"
                                aria-label="View selected order confirmation form"
                                icon
                                small
                                @click="onClickViewOrderConfirmationForm"
                            >
                                <v-icon aria-hidden="true" color="primary">mdi-eye</v-icon>
                            </v-btn>
                        </template>
                        <span>View Selected Order Confirmation Form</span>
                    </v-tooltip>
                </template>
            </v-select>

            <v-alert
                v-if="viewing_in_context_of_form_id && !order_confirmation_form_choices.find(choice => choice.value === viewing_in_context_of_form_id)"
                border="left"
                colored-border
                color="error"
                type="info"
                elevation="0"
                class="shaded-light py-2 px-6 mt-2"
                dense
            >
                <div class="d-flex align-center">
                    <div class="flex-grow-1">
                        <span class="text-body-2">
                            The order confirmation form you're currently editing is not published, so it's not yet available for selection here.
                        </span>
                    </div>
                </div>
            </v-alert>
        </div>

        <div class="mb-8">
            <v-alert
                v-if="show_form_link && order_confirmation_form_choices.length === 0"
                border="left"
                colored-border
                color="primary"
                type="info"
                elevation="0"
                class="shaded-light py-2 mt-2"
                dense
            >
                <div class="d-flex align-center">
                    <div class="flex-grow-1">
                        <span class="text-body-2">
                            No Published Order Confirmation forms found. Create one to associate it with this message.
                        </span>
                    </div>
                    <div class="ml-3">
                        <v-btn
                            color="primary"
                            plain
                            small
                            @click="onClickCreateOrderConfirmationForm"
                        >
                            Create Order Confirmation Form
                        </v-btn>
                    </div>
                </div>
            </v-alert>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        template: {
            type: Object,
            required: true
        },
        order_confirmation_form_choices: {
            type: Array,
            default: () => []
        },
        read_only: {
            type: Boolean,
            default: false
        },
        show_form_link: {
            type: Boolean,
            default: true
        },

        /**
         * If provided, indicates that the component is being viewed in the context of a specific order confirmation form.
         * This form id can be used to adjust behavior or display based on the context.
         */
        viewing_in_context_of_form_id: {
            type: String,
            default: null
        }
    },

    methods: {
        onUpdateOrderConfirmationSettingsId(value) {
            this.$emit('update:orderConfirmationSettingsId', value);
        },

        onClickViewOrderConfirmationForm() {
            this.$emit('view-form');
        },

        onClickCreateOrderConfirmationForm() {
            this.$emit('create-form');
        }
    }
}
</script>
